var RouteTypes;
(function (RouteTypes) {
    RouteTypes[RouteTypes["Agent"] = 0] = "Agent";
    RouteTypes[RouteTypes["Carrier"] = 1] = "Carrier";
    RouteTypes[RouteTypes["Common"] = 2] = "Common";
})(RouteTypes || (RouteTypes = {}));
;
export default RouteTypes;
